import Vue from 'vue'
import InfiniteScroll from './src/index'

Vue.directive('InfiniteScroll', InfiniteScroll)
